export default __webpack_public_path__ + "static/media/October2019.44ba5607.png";